<script>

import Logo from "@/components/Logo.vue";

export default {
    components: {Logo},
    data() {
        return {
            email: '',
            loading: false,
            error: null,
            errors: {}
        }
    },
    methods: {
        send() {
            this.loading = true;
            this.error = null;
            axios.post('/forgot-password', {email: this.email}).then(() => {
                this.$toast.open({
                    message: this.$t('auth.password_recovery.success_message'),
                    duration: 10000,
                });
                this.loading = false;
                this.$router.push({name: 'login'});
            }).catch((data) => {
                this.errors = data.response?.data?.errors || {};
                this.error = data.response?.data?.error;
            }).finally(() => {
                this.loading = false;
            })
        }
    }
}

</script>
<template>
    <section class="hero is-fullheight">
        <div class="hero-body">
            <div class="container">
                <a href="/"><Logo/></a>
                <div class="columns is-centered">
                    <div class="column is-6-tablet is-4-desktop is-4-widescreen">
                        <form @submit.prevent="send" class="panel is-link">
                            <p class="panel-heading">
                                {{ $t('auth.password_recovery.title_label') }}
                            </p>
                            <div class="box no-top-radius">
                                <p class="mb-5 is-size-6">
                                    {{ $t('auth.password_recovery.info_label') }}
                                </p>

                                <b-field :label="$t('auth.fields.email.name')"
                                         label-for="email"
                                         :type="error || errors.email ? 'is-danger' : null"
                                         :message="error || errors.email">
                                    <b-input required
                                             type="email"
                                             id="email"
                                             autofocus
                                             name="email"
                                             :placeholder="$t('auth.fields.email.placeholder')"
                                             v-model="email"
                                             icon="at"
                                    ></b-input>
                                </b-field>

                                <div class="buttons is-flex mt-6">
                                    <b-button @click="$router.push({name: 'login'})">
                                        {{ $t('actions.back') }}
                                    </b-button>
                                    <button class="button is-success is-flex-grow-5"
                                            type="submit"
                                            v-bind:disabled="loading"
                                            v-bind:class="{'is-loading': loading}">
                                        {{ $t('actions.send') }}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
